import { useTheme } from '@mui/material/styles';
import grey from "@mui/material/colors/grey";

export const MultiVariableFilterStyles = () => {
    const theme = useTheme();
    return {
        "& .custom-groups__loading": {
            background: "rgba(255, 255, 255, 0.5)",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: theme.palette.primary.light,
            fontWeight: "bold",
            zIndex: " 2",
        },
        "& .custom-groups__loading-message": {
            marginBottom: "10px"
        },
        "& .var-option__color-indicator": {
            width: "50px",
            height: "10px",
            display: "inline-block",
            marginRight: "6px",
            borderRadius: "5px"
        },
        "& span.filter__counter": {
            float: "right",
            paddingRight: "20px",
            fontSize: "12px",
            fontWeight: "bold",
            paddingTop: "4px",
        },
        "& .var-option": {
            background: `${grey[100]}`,
            padding: "4px 17px 12px",
            marginBottom: "4px",
            position: "relative",
        },
        "& .remove-filter": {
            borderRadius: "50%",
            boxShadow: "none",
            minWidth: "22px",
            height: "20px",
            padding: 0,
            position: "absolute",
            right: "4px",
            margin: "5px"
          }
    }
}